import React,{useState} from "react";
import classes from "./ClinicCard.module.css";

//components
import AnimatedCard from "../../UI/AnimatedCard/AnimatedCard";
import Button from "../../UI/Button/Button";
import Modal from "../../UI/Modal/Modal"
import AppointmentForm from "./AppointmentForm/AppointmentForm";

//This component displays the clinic information in a Card
// it takes: props.clinic

const ClinicCard = (props) => {
  const [isVisible,setIsVisible] = useState(false) //state responsible for opening the modal
  const [doctor,setDoctor] = useState("") //state responsible for selecting the doctor for the modal

  //close the modal
  const cancel = () =>{
    setIsVisible(false);
  }

  //open the modal
  const openModal = (event) =>{
    setDoctor(event.target.innerText)
    setIsVisible(true)
  }
  return (
    <AnimatedCard className={classes.container}>
      {isVisible && <Modal cancel={cancel} title="احجز موعد" circle={2500} >
          <AppointmentForm doctor={doctor} clinic={props.Clinic.ServName}/>
        </Modal>}
      <div>
        <h1>{props.Clinic.ServName}</h1>
      </div>
      <div className={classes.doctorsSection}>
        {
        <ul>
          {
          // maps the doctors to Buttons in the clinicCard
          props.Clinic.Doctors.map((Doctor) => {
            return (
              <Button
                key={Doctor.DocId}
                width={"150"}
                height={"50"}
                onClick={openModal}
              >{Doctor.DocName}</Button>
            );
          })}
        </ul>
        } 
      </div>
    </AnimatedCard>
  );
};
export default ClinicCard;
